import NewdogFiles from "../../components/newdog-files/newdog-files"
import { Button } from "devextreme-react/button"
import { useState } from "react"
import { useReqPopup } from "../../contexts/req-popup"

const NewdogFilesList = (props) => {
    const [visibleAddFile, setVisibleAddFile] = useState(false)
    //const [fileTypes, setFileTypes] =useState([])
    //const [filesSource, setFilesSource] = useState([])
    const {newdogFiles, setNewdogFiles} = useReqPopup()

    const addFileToNewreq = (type, files) => {
        const newEntries = Array.from(files).map((file) => ({
            id: Date.now() + Math.random(),
            type_id: type.id,
            type_name: type.nameType,
            file_name: file.name,
            file: file,
        }))
        const source = [...newdogFiles, ...newEntries]
        setNewdogFiles(source)
        props.onAddFiles && props.onAddFiles(source.length)
    }

    const removeFile = (idFile) => {
        let files = newdogFiles.filter(item => item.id !== idFile)
        setNewdogFiles(files)
        props.onAddFiles && props.onAddFiles(files.length)
    }

    return (
        <div>
            <div>
                {newdogFiles.length > 0 &&
                    <div className={'mb-2 mt-2'}><b>Документы:</b></div>
                }
                <ul className={''} style={newdogFiles.length > 0 ? {border: '1px solid lightgray'} : {}}>
                    {newdogFiles.length > 0 && 'Всего: ' + (newdogFiles.reduce((accum,i) => accum + +(i.file.size/1000),0)).toFixed(1) + ' Кбайт'}
                    {
                        newdogFiles.map((item) => {
                            return <li className={'m-2'} key={item.id}>
                                {item.type_name}: <u>{item.file_name}</u> {(item.file.size/1000).toFixed(1)} Кбайт (<a href="/" onClick={(e) => {removeFile(item.id); e.preventDefault()}}>Удалить</a>)
                            </li>}
                        )
                    }
                </ul>
            </div>
            <Button text="Добавить документы" icon="add" disabled={props.checkedInn} onClick={()=>{setVisibleAddFile(true)}}></Button>
            <NewdogFiles mode="newreq" visible={visibleAddFile} typeFileLimit={props.typeFileLimit} types={props.types} onClose={()=>{setVisibleAddFile(false)}} onAddFiles={addFileToNewreq} />
        </div>
    )
}

export default NewdogFilesList
